export const mutations = {
         setEntradaMercadoria(state, data) {
           state.entradaMercadoria = data;
         },
         setEntradasMercadorias(state, data) {
           state.entradasMercadorias = data;
         },
         addEntradaMercadoria(state, data) {
           state.entradasMercadorias.push(data);
         },
         removeEntradaMercadoria(state, data) {
           let index = state.entradasMercadorias.map((x) => x.id).indexOf(data.id);
           state.entradasMercadorias.splice(index, 1);
         },
         addItemEntradaMercadoria(state, data) {
           state.itensEntradaMercadoria = [...state.itensEntradaMercadoria, data];
         },
         setItensEntradaMercadoria(state, data) {
           state.itensEntradaMercadoria = data;
         },
         setContasPagarEntradaMercadoria(state, data) {
           state.contasPagarEntradaMercadoria = data;
         },
         addContaPagarEntradaMercadoria(state, data) {
           state.contasPagarEntradaMercadoria.push(data);
         },
         removeContaPagarEntradaMercadoria(state, data) {
           let indice = state.contasPagarEntradaMercadoria.map((x) => x.id).indexOf(data.id);
           state.contasPagarEntradaMercadoria.splice(indice, 1);
         },
         removeItemEntradaMercadoria(state, item) {
           let indice = state.itensEntradaMercadoria.indexOf(item);
           state.itensEntradaMercadoria.splice(indice, 1);
         },
         setModalCadastrarEntradaMercadoria(state, status) {
           state.modalCadastrarEntradaMercadoria = status;
         },
         setModalExcluirEntradaMercadoria(state, status) {
           state.modalExcluirEntradaMercadoria = status;
         },
         setModalPesquisarEntradaMercadoria(state, status) {
           state.modalPesquisarEntradaMercadoria = status;
         },
         setModalEnviarEmailEntradaMercadoria(state, status) {
           state.modalEnviarEmailEntradaMercadoria = status;
         },
       };

export default {}